module.exports = __webpack_public_path__ + "static/img/AL.3be3b0e1.svg";